import { Box, chakra } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

type HeroTextContentProps = {
  children: ReactNode;
  className?: string;
  /**
   * Centers all the text in the hero
   */
  center?: boolean;
};

type HeroTextContentContextProperties = {
  center?: boolean
}
export const HeroTextContentContext = React.createContext<HeroTextContentContextProperties>({});

/**
 * Title + Subtitle + Text wrapper component
 */
export default chakra(function HeroTextContent_({
  children,
  className,
  center
}: HeroTextContentProps) {
  return (
    <HeroTextContentContext.Provider value={{ center }}>
      <Box className={className}>{children}</Box>
    </HeroTextContentContext.Provider>
  )
});
